export default __webpack_public_path__ + "static/media/Bg-1.4c4e454e.png";